// Countries listing + country details events (analytics sheet → "All
// Countries Listing Page" and "Country Details Page" sections).
import {logAnalyticsEvent} from './analytics';
import {AnalyticsEntryPoint} from './events';
import {listingAnalytics} from './listing-page.analytics';
import type {TrackedItem} from './shared';

const DETAILS = AnalyticsEntryPoint.CountryDetailsPage;

// — Countries listing —

// Countries view_item_click also duplicates the item into country_id/country_name —
// a load-bearing deviation carried by the factory's viewExtra option.
const countries = listingAnalytics(AnalyticsEntryPoint.CountriesListingPage, {
  viewExtra: item => ({country_id: item.id, country_name: item.name}),
});

export const trackCountriesListingCardClick = countries.cardClick;
export const trackCountriesListingViewItemClick = countries.viewItemClick;
export const trackCountriesListingRegisterInterestClick = countries.registerInterestClick;

// — Country details —

export function trackCountryCardClick(item: TrackedItem) {
  logAnalyticsEvent('card_click', {
    entry_point: DETAILS,
    item_id: item.id,
    item_name: item.name,
  });
}

export function trackCountryViewItemClick(item: TrackedItem, country?: TrackedItem) {
  logAnalyticsEvent('view_item_click', {
    entry_point: DETAILS,
    item_id: item.id,
    item_name: item.name,
    country_id: country?.id,
    country_name: country?.name,
  });
}

export function trackCountryLearnMoreClick(item?: TrackedItem, redirectionLink?: string) {
  logAnalyticsEvent('learn_more_click', {
    entry_point: DETAILS,
    item_id: item?.id,
    item_name: item?.name,
    redirection_link: redirectionLink,
  });
}

export function trackCountryRegisterInterestClick(item?: TrackedItem) {
  logAnalyticsEvent('register_interest_click', {
    entry_point: DETAILS,
    item_id: item?.id,
    item_name: item?.name,
  });
}
